import { Button, styled } from "@mui/material";

export const ExtraSmallButtonAutomation = styled(Button)(() => ({
    minWidth: '24px',
    padding: '4px',
    height: '24px !important',
    '& .MuiButton-icon': {
        marginRight: 0
    },
    '& .MuiButton-root': {
        height: '24px'
    }
}))